import { pushToDataLayer } from '../datalayer';
import { EcommerceCartItem } from '../types';
import type { CloudRetailProductDetail } from './trackSearchResults';

export const trackViewItemList = ({
  currency,
  listName,
  viewedItems = [],
  count,
  searchTerm,
  searchMethod,
  resultsFilters,
  searchType,
  itemListSlot,
  itemListServiceConfig,
  cloudRetail,
  allowEmptyItems,
}: {
  currency?: string;
  listName?: string;
  viewedItems?: Array<EcommerceCartItem>;
  count?: number;
  searchTerm?: string;
  searchMethod?: string;
  resultsFilters?: {
    category?: string;
    price?: {
      min: string;
      max: string;
    };
    'Sale items'?: boolean;
  };
  searchType?: string;
  itemListSlot?: string;
  itemListServiceConfig?: string;
  cloudRetail?: {
    attributionToken?: string;
    filter?: string;
    productDetails?: Array<CloudRetailProductDetail>;
  };
  allowEmptyItems?: boolean;
}) => {
  if (!viewedItems?.length && !allowEmptyItems) return;

  const items =
    listName || itemListSlot || itemListServiceConfig
      ? viewedItems.map(item => ({
          ...item,
          ...(listName && { item_list_name: listName }),
          ...(itemListSlot && { item_list_slot: itemListSlot }),
          ...(itemListServiceConfig && { item_list_service_config: itemListServiceConfig }),
        }))
      : viewedItems;

  pushToDataLayer({
    event: 'view_item_list',
    count,
    search_term: searchTerm,
    search_type: searchType,
    method: searchMethod,
    filters: resultsFilters,
    item_list_name: listName || undefined,
    item_list_slot: itemListSlot || undefined,
    item_list_service_config: itemListServiceConfig || undefined,
    ecommerce: {
      currency: currency || '(unknown)',
      items,
    },
    ...(cloudRetail && {
      cloud_retail: {
        attributionToken: cloudRetail.attributionToken,
        filter: cloudRetail.filter ?? null,
        productDetails: cloudRetail.productDetails,
      },
    }),
  });
};
